import axios from "axios";

const BASE_URL = "http://216.38.6.193:3001";

export class Shipstation {
  
  private static _instance: Shipstation;

  private constructor() {}

  public static get instance() {

    return this._instance || (this._instance = new this());
  }

  async listCarriers() {
    const response = await axios.get(`${BASE_URL}/api/shipstation/list_carriers`);
    return response;
  }

  async packagesList (carrierCode: string) {
    const response = await axios.get(`${BASE_URL}/api/shipstation/list_packages?carrierCode=${carrierCode}`);
    return response;
  }

  async  getShipRates (payload: any) {
    const response = await axios.post(`${BASE_URL}/api/shipstation/get_ship_rates`,
        payload
    );
    return response;
  }
  
}
